import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-rapport-annuel',
  imports: [],
  templateUrl: './rapport-annuel.component.html',
  styleUrl: './rapport-annuel.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RapportAnnuelComponent {

}
